class QuoteSimple extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.onScroll = this.onScroll.bind(this);
    this.changeSlide = this.changeSlide.bind(this);
  }

  connectedCallback() {
    this.setupCarousel();
    this.setupDots();
    this.startSlideInterval();
    this.updateUI();
  }

  disconnectedCallback() {
    clearInterval(this.slideInterval);
    this.carousel.removeEventListener("scroll", this.onScroll);
    this.dots.forEach((dot) => dot.removeEventListener("click", this.goToSlide.bind(this)));
  }

  setupCarousel() {
    this.carousel = this.querySelector("#carousel");
    if (!this.carousel || this.carousel.children.length === 0) return;
    this.totalSlides = this.carousel.children.length;
    this.carouselWidth = this.carousel.offsetWidth;
    this.carousel.addEventListener("scroll", this.onScroll);
  }

  setupDots() {
    this.dots = this.querySelectorAll(".dot");
    this.dots.forEach((dot, index) => {
      dot.addEventListener("click", () => this.goToSlide(index));
    });
  }

  startSlideInterval() {
    this.slideInterval = setInterval(() => this.changeSlide(1), 16000);
  }

  onScroll() {
    const newCurrentIndex = Math.round(this.carousel.scrollLeft / this.carouselWidth);
    if (newCurrentIndex !== this.currentIndex) {
      this.currentIndex = newCurrentIndex;
      this.updateUI();
    }
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.carousel.scrollLeft = this.carouselWidth * this.currentIndex;
    this.updateUI();
  }

  updateUI() {
    this.dots.forEach((dot, index) => {
      dot.classList.toggle("opacity-100", index === this.currentIndex);
      dot.classList.toggle("opacity-30", index !== this.currentIndex);
    });
    clearInterval(this.slideInterval);
    this.startSlideInterval();
  }

  changeSlide(direction) {
    this.currentIndex = (this.totalSlides + this.currentIndex + direction) % this.totalSlides;
    this.carousel.scrollLeft = this.carouselWidth * this.currentIndex;
    this.updateUI();
  }
}

customElements.define("quote-simple", QuoteSimple);
